import React, { useEffect } from 'react';
import './Blog.scss';
import soc2Image from '../../assets/images/blog/blog_post_1.png';
import cloudSecImage from '../../assets/images/blog/blog_post_2.jpeg';
import { setPageTitle } from '../../utils/title';
import Breadcrumb from '../../components/Breadcrumb';
import { Link } from 'react-router-dom';

const Blog = () => {
  useEffect(() => {
    setPageTitle('Blog');
  }, []);

  const breadcrumbItems = [
    { path: '/', label: 'Home' },
    { path: '/blog', label: 'Blog' },
  ];

  return (
    <div className="blog-page">
      <Breadcrumb items={breadcrumbItems} />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">Blog</h1>
        </div>
      </section>

      <section className="blog-series-section section section--light">
        <div className="container">
          <div className="services__grid">
            {/* SOC 2 for Lean Startups */}
            <div className="card service-card">
              <img
                src={soc2Image}
                alt="SOC 2 for Lean Startups"
                style={{
                  borderRadius: '8px',
                  marginBottom: '1rem',
                  width: '100%',
                  height: '180px',
                  objectFit: 'cover',
                }}
              />
              <h3 className="card__title">
                <Link
                  to="/blog/soc2-for-lean-startups"
                  className="card__title"
                  style={{ textDecoration: 'none' }}
                >
                  SOC 2 for Lean Startups
                </Link>
              </h3>
              <p className="card__description">
                A practical guide to SOC 2 compliance for lean teams and startups.
              </p>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Link
                  to="/blog/soc2-for-lean-startups"
                  className="btn btn--primary"
                  style={{ alignSelf: 'flex-end' }}
                >
                  View Series
                </Link>
              </div>
            </div>

            {/* Cloud Security Series */}
            <div className="card service-card">
              <img
                src={cloudSecImage}
                alt="Cloud Security Series"
                style={{
                  borderRadius: '8px',
                  marginBottom: '1rem',
                  width: '100%',
                  height: '180px',
                  objectFit: 'cover',
                }}
              />
              <h3 className="card__title">
                <Link
                  to="/blog/cloud-security-series"
                  className="card__title"
                  style={{ textDecoration: 'none' }}
                >
                  Cloud Security Series
                </Link>
              </h3>
              <p className="card__description">
                Deep dives and practical tips for securing your cloud infrastructure.
              </p>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Link
                  to="/blog/cloud-security-series"
                  className="btn btn--primary"
                  style={{ alignSelf: 'flex-end' }}
                >
                  View Series
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
